import AllCities from "../components/AllCities";
import Breadcrumb from "../components/Breadcrumb";

const AllCitiesPage = () => {
  return (
    <>
      <Breadcrumb title="All Cities" />

      <AllCities />
    </>
  );
};

export default AllCitiesPage
